'use client';
import { Link, LinkProps } from '@heroui/link';
import {
  Navbar as NUINavbar,
  NavbarBrand as NUINavbarBrand,
  NavbarContent as NUINavbarContent,
  NavbarItem as NUINavbarItem,
  NavbarProps,
} from '@heroui/navbar';
import NavLink from '@Soultrics/_components/NavLink';

export default function Navbar(props: NavbarProps) {
  return (
    <NUINavbar
      isBordered
      shouldHideOnScroll
      className="bg-content1 px-4"
      classNames={{
        item: [
          'flex',
          'relative',
          'h-full',
          'items-center',
          'mx-2',
          "data-[active=true]:after:content-['']",
          'data-[active=true]:after:absolute',
          'data-[active=true]:after:bottom-0',
          'data-[active=true]:after:left-0',
          'data-[active=true]:after:right-0',
          'data-[active=true]:after:h-[2px]',
          'data-[active=true]:after:rounded-[2px]',
          'data-[active=true]:after:bg-primary',
        ],
      }}
      maxWidth="full"
      {...props}
    />
  );
}

export function NavbarLink(props: LinkProps) {
  return (
    <NavLink as={NUINavbarItem} href={props.href}>
      <Link {...props} />
    </NavLink>
  );
}

export const NavbarContent = NUINavbarContent;
export const NavbarBrand = NUINavbarBrand;
